import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-8 bg-brand-alt px-4 py-20 md:py-28" data-id="element-316">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-317">
        <h2 className="mb-12 text-3xl font-black md:text-4xl" data-id="element-318">
          🏆 Special Launch Offer
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-red bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-319">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-red px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-320">
            ART READY PACK
          </div>
          <div className="space-y-4 text-left" data-id="element-321">
            <PriceLine label="10 Complete Digital Volumes" price="$77" data-id="element-322" />
            <PriceLine label="5 Exclusive Bonuses" price="$135" data-id="element-323" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-324">
              <span data-id="element-325">TOTAL VALUE:</span>
              <span className="text-brand-orange line-through" data-id="element-326">$212 USD</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-327">
            <p className="font-serif text-6xl font-black tracking-tight text-brand-red md:text-7xl" data-id="element-328">
              🏆 $27 <span className="text-2xl" data-id="element-329">USD</span>
            </p>
          </div>
          <CTAButton href="https://art-ready.impultienda.ar/checkout" className="w-full py-5 text-lg" data-id="element-330">
            GET THE ART READY PACK
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-331">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-332">
      <span className="font-medium" data-id="element-333">{label}</span>
      <span className="font-bold text-brand-red" data-id="element-334">{price}</span>
    </div>;
}